import { NgModule } from "@angular/core";
import {NgbModal, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from "@angular/common";
import { OrderComponent } from "./order.component";
import { OrderListComponent } from "./order-list/order-list.component";
import { CoreModule } from "../../../../core/core.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { PartialsModule } from "../../../partials/partials.module";
import { OrderRoutingModule } from "./order-routing.module";
import { TranspopModule } from "../transpop.module";
import { Step1Component } from "./wizards/step1/step1.component";
import { Step2Component } from "./wizards/step2/step2.component";
import { OrderService } from "./services/order-service";
import { Step3Component } from "./wizards/step3/step3.component";
import { ComponentViewDirective } from "./wizards/step3/cmp-directive";
import { ToRequestWarehouseComponent } from "./wizards/step3/toRequest/to-request-warehouse/to-request-warehouse.component";
import { ToRequestDistributorComponent } from "./wizards/step3/toRequest/to-request-distributor/to-request-distributor.component";
import { FromReceiveMobilWarehouseComponent } from "./wizards/step3/fromReceive/from-receive-mobil-warehouse/from-receive-mobil-warehouse.component";
import { FromReceiveWarehouseComponent } from "./wizards/step3/fromReceive/from-receive-warehouse/from-receive-warehouse.component";
import {
	MAT_DIALOG_DEFAULT_OPTIONS,
	MatRadioModule,
	MatCheckboxModule,
	MatPaginatorModule,
	MatSortModule,
	MatProgressSpinnerModule,
	MatAutocompleteModule,
	MatNativeDateModule,
	MatFormFieldModule,
	MatInputModule,
	MatButtonModule,
	MatCardModule,
	MatChipsModule,
	MatSelectModule,
	MatProgressBarModule,
	MatIconModule,
	MatSliderModule,
	MatSidenavModule,
	MatSnackBarModule,
	MatStepperModule,
	MatToolbarModule,
	MatDividerModule,
	MatTabsModule,
	MatTableModule,
	MatTooltipModule,
	MatListModule,
	MatGridListModule,
	MatButtonToggleModule,
	MatExpansionModule,
	MatMenuModule,
	MatTreeModule,
	MAT_BOTTOM_SHEET_DATA,
	MAT_DATE_LOCALE,
	MAT_DATE_FORMATS,
} from "@angular/material";
import { ToRequestStaticSalesLocationComponent } from "./wizards/step3/toRequest/to-request-static-sales-location/to-request-static-sales-location.component";
import { ToRequestAddAddressToPersonCategoryComponent } from "./wizards/step3/toRequest/to-request-add-address-to-person-category/to-request-add-address-to-person-category.component";
import { OrderServiceProxy } from '../../../../../shared/service-proxies/service-proxies';
import { AddressSimilarityModalComponent } from './wizards/step3/address-similarity-modal/address-similarity-modal.component';
import { ClaimConfirmationComponent } from './claim-confirmation/claim-confirmation.component';
import { MyPastRequestsComponent } from './claim-confirmation/my-past-requests/my-past-requests.component';
import { MyPendingRequestsComponent } from './claim-confirmation/my-pending-requests/my-pending-requests.component';
import { RequestsPendingMyApprovalComponent } from './claim-confirmation/requests-pending-my-approval/requests-pending-my-approval.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ImageModalComponent } from './wizards/step3/image-modal/image-modal.component';
import { ProductApprovalOrRejectModalComponent } from './claim-confirmation/product-approval-or-reject-modal/product-approval-or-reject-modal.component';
import { ApproveStatusModalComponent } from './claim-confirmation/approve-status-modal/approve-status-modal.component';
import { SktLotModalComponent } from './wizards/step3/skt-lot-modal/skt-lot-modal.component';
import { SharedModule } from '@shared/shared.module';
import { AbpModule } from 'abp-ng2-module/dist/src/abp.module';
import { CustomDescriptionModule } from '../shared/custom-description/custom-description.module';
import { SpecialCodeModalComponent } from './wizards/step3/special-code-modal/special-code-modal.component';
import { InsufficientStockModalComponent } from './wizards/step3/insufficient-stock-modal/insufficient-stock-modal.component';
import { OfferFormComponent } from './offer-form/offer-form.component';
import { OfferConfirmationFormComponent } from './offer-confirmation-form/offer-confirmation-form.component';
import { DirectiveModule } from '../shared/directives/directive.module';
import { ProductHistoryViewInformationComponent } from './claim-confirmation/product-history-view-information/product-history-view-information.component';
import { ToRequestTransferComponent } from './wizards/step3/toRequest/to-request-transfer/to-request-transfer.component';
import { ComponentViewTopDirective } from './wizards/step3/cmp-top.directive';

@NgModule({
	declarations: [
		OrderComponent,
		OrderListComponent,
		Step1Component,
		Step2Component,
		Step3Component,
		ComponentViewDirective,
		ToRequestWarehouseComponent,
		ToRequestDistributorComponent,
		FromReceiveMobilWarehouseComponent,
		FromReceiveWarehouseComponent,
		ToRequestStaticSalesLocationComponent,
		ToRequestAddAddressToPersonCategoryComponent,
		AddressSimilarityModalComponent,
		ClaimConfirmationComponent,
		MyPastRequestsComponent,
		MyPendingRequestsComponent,
		RequestsPendingMyApprovalComponent,
		ImageModalComponent,
		ProductApprovalOrRejectModalComponent,
		ApproveStatusModalComponent,
		SktLotModalComponent,
		SpecialCodeModalComponent,
		InsufficientStockModalComponent,
		OfferFormComponent,
		OfferConfirmationFormComponent,
		ProductHistoryViewInformationComponent,
		ToRequestTransferComponent,
		ComponentViewTopDirective,
		//yy
	],
	imports: [
		//Abp Module olmadığında static injector hatası alınıyor ve api ye istek gitmiyor.
		AbpModule,
		CoreModule,
		MatRadioModule,
		MatCheckboxModule,
		MatPaginatorModule,
		MatSortModule,
		MatProgressSpinnerModule,
		MatAutocompleteModule,
		MatNativeDateModule,
		MatFormFieldModule,
		MatInputModule,
		MatButtonModule,
		MatCardModule,
		MatChipsModule,
		MatSelectModule,
		MatProgressBarModule,
		MatIconModule,
		MatSliderModule,
		MatSidenavModule,
		MatSnackBarModule,
		MatStepperModule,
		MatToolbarModule,
		MatDividerModule,
		MatTabsModule,
		MatTableModule,
		MatTooltipModule,
		MatListModule,
		MatGridListModule,
		MatButtonToggleModule,
		MatExpansionModule,
		MatMenuModule,
		MatTreeModule,
		CommonModule,
		OrderRoutingModule,
		TranspopModule,
		FormsModule,
		ReactiveFormsModule,
		NgbModule,
		NgxMatSelectSearchModule,
		PartialsModule,
		CustomDescriptionModule,

		DirectiveModule
	],
	providers: [
		OrderService,
		OrderServiceProxy,

	],
	entryComponents: [
		ToRequestDistributorComponent,
		ToRequestWarehouseComponent,
		ToRequestTransferComponent,
		FromReceiveMobilWarehouseComponent,
		FromReceiveWarehouseComponent,
		ToRequestStaticSalesLocationComponent,
		ToRequestAddAddressToPersonCategoryComponent,
		AddressSimilarityModalComponent,
		ImageModalComponent,
		ProductApprovalOrRejectModalComponent,
		ApproveStatusModalComponent,
		SktLotModalComponent,
		SpecialCodeModalComponent,
		InsufficientStockModalComponent,
		ProductHistoryViewInformationComponent
	],
})
export class OrderModule {}
